define('row_view.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('row_view', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"row-view\"><div data-type=\"backbone.collection.view.cells\"></div></div>  ";
},"useData":true}, 'extensions/Tavanoteam/TT_C2C_Master_Theme/1.9.7/', 'extensions/Tavanoteam/TT_C2C_Master_Theme/1.9.7/', Handlebars);
});